import { yup } from '@guiker/shared-framework'

export const attachRentalContractSchema = yup.object({
  rentalContractId: yup.string().required(),
})
